export const RECENT_HISTORY_LIST = 'recent_history_list';
export const RECENT_HISTORY_COUNT = 'recent_history_count';
export const MAX_DAYS = 30;
export const MAX_RECENTLY_VIEWED_ITEMS = 12;
